export default __webpack_public_path__ + "static/media/WatersEdge.037fdbd9.jpg";